// @flow

import {Tag, extractLinksFromMarkdocList, findMarkdocTag} from 'docs/util';

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const CardGroup: MarkdocTagRegistration = {
  tag: 'card-group',
  component: 'CardGroup',
  attributes: {
    footerLink: {
      type: Object,
      required: false,
      description: 'The link displayed at the bottom right of the card group',
      localizable: ['label'],
    },
    removePadding: {
      type: Boolean,
      required: false,
      description: 'Set to true to Remove padding below the card group',
    },
  },
  render(node, config) {
    const attributes = node.renderAttributes(this.attributes, config);
    const children = node.renderChildren(config);

    const quickLinksTag = findMarkdocTag(
      children,
      (tag) => tag.name === 'CardGroupQuickLinks',
    );

    const list = quickLinksTag
      ? findMarkdocTag(quickLinksTag.children, (tag) => tag.name === 'List')
      : null;

    const quickLinks = list ? extractLinksFromMarkdocList(list) : [];

    return new Tag(
      this.tag,
      {...attributes, quickLinks},
      children.filter((child) => child !== quickLinksTag),
    );
  },
};
